var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var Svg404 = function Svg404(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 255,
    height: 111,
    fill: "none",
    viewBox: "0 0 255 111",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M49.95 98.9a7.75 7.75 0 0 0 15.5 0V82.35h7.25a7 7 0 1 0 0-14h-7.25V10.98c0-5.512-4.468-9.98-9.98-9.98a9.98 9.98 0 0 0-8.016 4.035L1.968 66.366A10.02 10.02 0 0 0 0 72.33c0 5.523 4.477 10.02 10 10.02h39.95zm0-30.55H18.79l31.16-42.58zM224.95 101.9a7.75 7.75 0 0 0 15.5 0V85.35h7.25a7 7 0 1 0 0-14h-7.25V13.98a9.98 9.98 0 0 0-17.996-5.945l-45.486 61.331A10.02 10.02 0 0 0 175 75.33c0 5.523 4.477 10.02 10 10.02h39.95zm0-30.55h-31.16l31.16-42.58z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 12,
    d: "M111.483 12.64C103.914 13.38 98 19.764 98 27.528v62.509C98 98.3 104.699 105 112.963 105h30.074C151.301 105 158 98.3 158 90.037v-62.51c0-7.763-5.914-14.146-13.483-14.887A12.57 12.57 0 0 0 133.432 6h-10.864a12.57 12.57 0 0 0-11.085 6.64Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B71717",
    d: "M107.382 87.262c0-.849.688-1.537 1.537-1.537h38.731c.849 0 1.537.688 1.537 1.537v2.766a6.15 6.15 0 0 1-6.148 6.148H113.53a6.15 6.15 0 0 1-6.148-6.148z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#232323",
    d: "M107.382 30.087c0 .85.688 1.537 1.537 1.537h38.731c.849 0 1.537-.688 1.537-1.537v-2.766a6.15 6.15 0 0 0-6.148-6.148H113.53a6.147 6.147 0 0 0-6.148 6.148zM107.382 74.351c0-.848.688-1.537 1.537-1.537h38.731c.849 0 1.537.689 1.537 1.537v7.378c0 .849-.688 1.537-1.537 1.537h-38.731a1.537 1.537 0 0 1-1.537-1.537zM107.382 61.441c0-.849.688-1.537 1.537-1.537h38.731c.849 0 1.537.688 1.537 1.537v7.377c0 .85-.688 1.537-1.537 1.537h-38.731a1.537 1.537 0 0 1-1.537-1.537zM107.382 48.53c0-.848.688-1.536 1.537-1.536h38.731c.849 0 1.537.688 1.537 1.537v7.377c0 .849-.688 1.537-1.537 1.537h-38.731a1.537 1.537 0 0 1-1.537-1.537zM107.382 35.62c0-.848.688-1.536 1.537-1.536h38.731c.849 0 1.537.688 1.537 1.536v7.378c0 .849-.688 1.537-1.537 1.537h-38.731a1.537 1.537 0 0 1-1.537-1.537z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#404_svg__a)",
    d: "M119.463 43.305h24.498l-4.935 6.461h-23.96z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m119.487 51.56-3.195 8.973h14.065l2.836-4.487h-9.179l2.498-4.487z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m119.107 62.329-2.871 9.333 8.838-9.333z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "404_svg__a",
    x1: 124.591,
    x2: 147.405,
    y1: 46.499,
    y2: 46.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A0AFF"
  })))));
};
export default Svg404;